// extracted by mini-css-extract-plugin
module.exports = {"dot1":"Loader_dot1__2S-VW","dot2":"Loader_dot2__2udcp","dot3":"Loader_dot3__sXgrB","dot-fade":"Loader_dot-fade__1-Grj"};